import type { ISession } from "@mne-authentication/api";

import { PageNotFound } from "@mnemonic/mui";
import { getMetaInfo } from "@mnemonic/pure-utils";
import type { TRouteDefinition } from "@mnemonic/router";

import { Swagger } from "../Pages/Swagger";
import { logRoute } from "./interceptors";

const PageNotFoundComponent = () => (
  <div style={{ marginTop: "64px" }}>
    <PageNotFound contact={getMetaInfo().email} />
  </div>
);

export const routeDefinitions: Array<TRouteDefinition<{ session: ISession }>> = [
  { path: "", component: Swagger, interceptors: [logRoute()] },
  { path: "/*", component: PageNotFoundComponent, interceptors: [logRoute()] },
];
